<template>
  <div :menu-fix="false">
    <div class="fix-wrapper">
      <breadcrumb
        :crumbs="[$t('menu.workerSalaries'), $t('text.edit')]"
      ></breadcrumb>
      <div class="container">
        <el-form
          ref="settleObjForm"
          :model="settleObj"
          label-width="100px"
          size="small"
        >
          <div class="pd20">
            <vxe-table
              :data="items"
              ref="itemsTable"
              class="recordsTable"
              size="mini"
              highlight-hover-row
              :scroll-y="{ enabled: false }"
            >
              <vxe-table-column
                field="images"
                :title="$t('product.images')"
                width="85"
              >
                <template v-slot="{ row }">
                  <thumbnail :images="row.workOrder.images"></thumbnail>
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="serialNo"
                :title="$t('text.serialNo')"
                min-width="130"
              >
                <template v-slot="{ row }">
                  {{ row.workOrderSn }}
                  <div>
                    <state-label :state="row.workOrder.workflowState">{{
                      $t("workOrderStates." + row.workOrder.workflowState)
                    }}</state-label>
                    <div class="font10">
                      {{ row.workOrder.customerName }}
                    </div>
                  </div>
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="productNo"
                :title="$t('product.productNo')"
                min-width="100"
              >
                <template v-slot="{ row }">
                  {{ row.workOrder.productNo }}
                  <small v-if="row.workOrder.orderCustomerProductNo != null"
                    >({{ row.workOrder.orderCustomerProductNo }})</small
                  >

                  <div v-if="row.workOrder.category != null" class="font10">
                    {{ row.workOrder.category }}
                  </div>
                  <div
                    v-if="
                      row.workOrder.color != null && row.workOrder.size != null
                    "
                    class="font10"
                  >
                    {{ row.workOrder.color }}
                    {{ row.workOrder.size }}
                  </div>
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="phaseName"
                :title="$t('menu.phases')"
                min-width="90"
              >
                <template v-slot="{ row }">
                  {{ row.phaseName }}
                  <div class="font10">{{ row.phaseHour }}小时</div>
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="quantity"
                :title="$t('text.quantity')"
                min-width="90"
              >
                <template v-slot="{ row }">
                  {{ row.quantity }}{{ row.workOrder.unit }}
                  <div class="font10">
                    {{ $t("factory.phasePrice") }}:
                    {{ row.phasePrice | currency }}
                  </div>
                </template>
              </vxe-table-column>

              <vxe-table-column
                field="subTotal"
                :title="'工价'"
                min-width="100"
              >
                <template v-slot="{ row }">
                  <el-input v-model="row.amount" size="small"></el-input>
                  <el-input
                    v-model="row.settleRemark"
                    size="small"
                    :placeholder="$t('settlement.explain')"
                  ></el-input>
                </template>
              </vxe-table-column>
              <vxe-table-column
                :title="$t('workOrder.productionSituation')"
                min-width="120"
              >
                <template v-slot="{ row }">
                  <div class="font10">
                    {{ $t("rules.startAt", []) }}:{{ row.startAt }}
                  </div>
                  <div class="font10">
                    {{ $t("rules.endAt", []) }}:{{ row.endAt }}
                  </div>
                </template>
              </vxe-table-column>
              <vxe-table-column :title="'工单备注'" min-width="80">
                <template v-slot="{ row }">
                  <raw-html-limit-number
                    :content="row.workOrder.remark"
                    :number="6"
                    type="richText"
                  ></raw-html-limit-number>
                </template>
              </vxe-table-column>

              <vxe-table-column :title="'生产记录备注'" min-width="80">
                <template v-slot="{ row }">
                  <raw-html-limit-number
                    :content="row.remark"
                    :number="6"
                    type="richText"
                  ></raw-html-limit-number>
                </template>
              </vxe-table-column>
            </vxe-table>
          </div>
          <div class="form-footer">
            <el-button
              type="primary"
              size="medium"
              plain
              :loading="saveDoing"
              @click="saveSubmit"
              >{{ $t("text.submit") }}</el-button
            >
            <back-button />
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Vue from "vue";
import ls from "store2";
import { page } from "@/utils/mixins.js";
import Util from "@/utils/index.js";
import BackButton from "@/components/BackButton";
import RawHtmlLimitNumber from "@/components/RawHtmlLimitNumber";
//
import Manufacture from "@/api/manufacture.js";

export default {
  mixins: [page],
  components: {
    BackButton,
    RawHtmlLimitNumber,
  },
  data() {
    return {
      items: [],
      Util: Util,
      settleObj: {},

      saveDoing: false,
    };
  },
  mounted() {},
  created() {
    const self = this;
    self.loadingStart();
    axios.all([Manufacture.findBySalaryId(self.$route.params.id)]).then(
      axios.spread(function (items) {
        self.loadingEnd();

        if (items.status === 200) {
          self.items = items.data;
        } else {
          self.sysError();
        }
      })
    );
  },

  methods: {
    //
    saveSubmit() {
      const self = this;
      for (const item of self.items) {
        if (!Util.regexQuantity(item.amount)) {
          self.$message({
            message: self.$t("rules.regex", ["工价"]),
            type: "warning",
          });
          return;
        }
      }
      const data = self.items.map((m) => {
        return { id: m.id, amount: m.amount, settleRemark: m.settleRemark };
      });

      self.saveDoing = true;
      Manufacture.batchUpdateAmountAndSettleRemark(data).then(function (res) {
        self.saveDoing = false;
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.editSuccess"),
            type: "success",
          });
          self.$router.push({
            name: "fnReportsWorkerSalaries",
          });
        } else {
          self.sysError();
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.name {
  text-overflow: ellipsis;
  overflow: hidden;
}
.addr {
  font-size: 12px;
  color: #b4b4b4;
}
</style>